export default "__VITE_ASSET__edvcn$AV__"